<template>
  <div class="list-item">
    <item-Details v-for="(item,index) in recipesList" :key="item.id" :details="item"
                  @handleCollect="handleCollect(item)" @handleDetails="handleDetails"></item-Details>
  </div>
</template>

<script>
import itemDetails from "./itemDetails";

export default {
  name: "listItem",
  components: {
    itemDetails
  },
  data() {
    return {}
  },
  props: {
    recipesList: {
      type: Array
    }
  },
  watch: {
    // recipesList: {
    //   handler(newValue) {
    //     console.log(newValue, 'newValue')
    //     newValue.forEach(item => {
    //
    //     })
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  created() {

  },

  methods: {
    handleDetails(value) {
      this.$emit('handleDetails', value)
    },
    handleCollect(value) {
      this.$emit('handleCollect', value)
    }
  }
}
</script>

<style lang="less" scoped>
</style>